import { ReactComponent as EyeClosed } from "../../img/icons/icon_black_eye_slash.svg";
import { ReactComponent as EyeOpned } from "../../img/icons/icon_black_eye.svg";
import { ReactComponent as Lock } from "../../img/create-new-pwd.svg";
import { ReactComponent as GreenTick } from "../../img/icons/icon_tick_green.svg";
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import BackButton from "../../img/icons/icon_blue_back.svg";
import { useTranslation } from "react-i18next";

function UpdatePassword() {
  const [state, setState] = useState({ pwd: "", confirmPwd: "" });
  const history = useHistory();
  const { t } = useTranslation();
  const [validation, setValidation] = useState({
    message: "",
    status: true,
  });

  useEffect(() => {
    validator();
  }, [state]);

  const validator = () => {
    if (state.pwd && state.pwd !== state.confirmPwd) {
      setValidation({
        message: t("sidenav.PASSWORD.message5"),
        status: false,
      });
    } else if (state.pwd.length < 8 || state.confirmPwd.length < 8) {
      setValidation({
        message: t("sidenav.PASSWORD.message3"),
        status: false,
      });
    } else {
      setValidation({
        message: "",
        status: true,
      });
    }
  };

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  // update password
  const changePassword = async () => {
    const token = "Bearer " + localStorage.getItem("token");
    const patientId = JSON.parse(localStorage.getItem("pid"));
    const PATCH_URL = `/api/v1/users/profile/${patientId}`;
    try {
      const data = {
        password: state.pwd,
      };
      const response = await fetch(`${PATCH_URL}`, {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=utf-8",
          Authorization: token.replace(/['"]+/g, ""),
        },
        body: JSON.stringify(data),
        credentials: "include",
      });
      const res = await response.json();
      console.log(res);

      if (!response.status === 200) {
        const error = new Error(response.error);
        throw error;
      } else {
        localStorage.removeItem("token");
        localStorage.removeItem("pid");
        localStorage.removeItem("Date");
        localStorage.removeItem("i18nextLng");
        history.push("/login");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleClick = () => {
    changePassword();
    history.push("/setting");
  };

  const [isPasswordShow, setIsPasswordShow] = useState(false);
  const toggleIsPasswordShowValue = () => {
    setIsPasswordShow(!isPasswordShow);
  };

  return (
    <>
      <header className="border_bottom">
        <div className="inner_header">
          <Link to="/setting" className="icon_left d-flex align-items-center">
            <img src={BackButton} alt="" className="img-fluid" />
            <span className="head_title">{t("sidenav.PASSWORD.detail")}</span>
          </Link>
        </div>
      </header>
      <div className="pwd_content ">
        <div className="thumbnail wow zoomIn mt-5">
          <Lock className="img-fluid" />
        </div>
        <div className="section_title">
          <h4 className="maintitle">{t("sidenav.PASSWORD.message")}</h4>
        </div>
        <div className="fill_form light_fill_form">
          <div className="field_group field_lbl_active">
            <label className="field_lbl">
              {t("sidenav.PASSWORD.message2")}
            </label>
            <input
              type={isPasswordShow ? "text" : "password"}
              className="field_input field_black_pwd"
              placeholder=""
              autoComplete="off"
              name="pwd"
              onChange={handleChange}
              value={state.pwd}
            />
            {state.pwd && (
              <span
                className="icon btn_black_pwd"
                onClick={toggleIsPasswordShowValue}
              >
                {isPasswordShow ? (
                  <EyeOpned className="img-fluid img_eye_black" />
                ) : (
                  <EyeClosed
                    className="img-fluid img_eye_black"
                    id="img_eye_black"
                  />
                )}
              </span>
            )}

            <span className="txt_help">{t("sidenav.PASSWORD.message3")}</span>
          </div>
          <p className="headtitle text-start mb-4">
            {t("sidenav.PASSWORD.message4")}
          </p>
          <div className="field_group field_lbl_active">
            <label className="field_lbl">
              {t("sidenav.PASSWORD.message4")}
            </label>
            <input
              type="password"
              className="field_input"
              placeholder=""
              autoComplete="off"
              name="confirmPwd"
              onChange={handleChange}
              value={state.confirmPwd}
            />
            {validation.status && state.pwd !== "" && (
              <span className="icon btn_black_pwd">
                <GreenTick className="img-fluid" />
              </span>
            )}
            {validation.status && (
              <span className="txt_help txt_color_green">
                {t("sidenav.PASSWORD.message7")}
              </span>
            )}
            {!validation.status && state.confirmPwd !== "" && (
              <span className="txt_help " style={{ color: "red" }}>
                {validation.message}
              </span>
            )}
          </div>
          <div className="btn_block d-flex justify-content-center bottom_button">
            <button
              className="btn btn_primary"
              onClick={handleClick}
              disabled={!validation.status}
              data-bs-toggle="modal"
              data-bs-target="#modal_password"
            >
              {t("appointment.BUTTON.save")}
            </button>
          </div>
        </div>
      </div>
      <div className="custom_modal modal fade text-center" id="modal_password">
        <div className="modal-dialog d-flex align-items-center top-0">
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <button
                id="modal_password"
                type="button"
                className="btn-close btn-dark-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="content_modal text-start p-2">
                <h3 className="maintitle maintitle_txt_color_black text-center pb-3">
                  {t("sidenav.PASSWORD.message6")}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpdatePassword;
